/*!
 * @copyright	Copyright (C) 2016 Piotr Konieczny. All rights reserved.
 * @license		GNU General Public License version 2 or later; see LICENSE.txt
 */

/**
 * Wgmedia.eu template
 *
 * Hard Dependencies
 * - jQuery
 *
 * Soft dependencies:
 * - Joomla
 */
window.WgTemplate = (function() {

    'use strict';

    /**
     * Template
     *
     * @class
     *
     * @param {Object} options
     */
    function WgTemplate(options) {

        this.options = (options || {});

        /** @type {Object} Hashmap of common elements */
        this.$els = {};

        /** @type {array} */
        this.extensions = [];

        /** @type {function} */
        this.joomlaRenderMessages = undefined;

        /** @type {function} */
        this.joomlaRemoveMessages = undefined;

        /** @type {Ya.Metrika} */
        this.yandexCounter = undefined;

        this.dispatch();
    }

    /**
     * Dipatch template
     *
     * @return {WgTemplate}
     */
    WgTemplate.prototype.dispatch = function() {

        this.preConfigureComponents();

        jQuery
            // Asynchronous
            .when(isDomReady())
            .then(jQuery.proxy(function() {
                this.configureComponents.call(this);
                this.setCommonElements.call(this);
                this.attachListeneres.call(this);
            }, this))
        ;

        return this;
    };

    /**
     * Set common elements
     *
     * @return {WgTemplate}
     */
    WgTemplate.prototype.setCommonElements = function() {

        this.$els.window = jQuery(window);
        this.$els.document = jQuery(window.document);

        this.$els.optionMenu = jQuery('[data-wg-optionmenu]');
        this.$els.orderingMenu = jQuery('[data-wg-orderingmenu]');
        this.$els.links = jQuery('a:not([href*="mailto:"], [href*="javascript:"])');

        this.$els.headerBar = jQuery('.wg-section-headerbar');

        this.$els.snapshotButton = jQuery('.plgContentPczLoadVideo-snapshot-button');

        this.headerBarHeight = this.$els.headerBar.height();

        this.slideshowContainerMinHeight = 120;
        this.slideshowContainerOriginalHeight = jQuery('.wg-slidenav').height();

        return this;
    };

    /**
     * Attach event listeners
     *
     * @return {WgTemplate}
     */
    WgTemplate.prototype.attachListeneres = function() {

        // Initial state
        this.onWindowScroll();
        this.$els.window.one('scroll', jQuery.proxy(this.onWindowScroll, this));
        this.$els.window.on('scroll', UIkit.Utils.debounce(jQuery.proxy(this.onWindowScroll, this), 50));

        this.$els.optionMenu.on('change', jQuery.proxy(this.onOptionMenuChange, this));
        this.$els.orderingMenu.on('change', jQuery.proxy(this.onOrderingMenuChange, this));
        this.$els.links.on('click', jQuery.proxy(this.onLinkClick, this));

        this.$els.snapshotButton.on('click', jQuery.proxy(this.onSnapshotButtonClick, this));

        // Close
        // this.$els.document.on('click', '.uk-close', function(event) {});

        return this;
    };

    /**
     * Configure FB before library is loaded (equivalent to `FB.init()` directly after FB script)
     *
     * @return {WgTemplate}
     *
     * @see https://developers.facebook.com/docs/javascript/quickstart
     */
    WgTemplate.prototype.preConfigureComponents = function() {

        // Prepare configuration that is invoked when global FB object is available
        if (this.options.facebook.appId) {
            window.fbAsyncInit = jQuery.proxy(this.initializeFacebook, this);
        }

        // See https://yandex.com/support/metrica/code/counter-initialize.xml
        if (this.options.yandex && this.options.yandex.counterId) {
            jQuery(document).on('yacounter' + this.options.yandex.counterId + 'inited', jQuery.proxy(function() {
                this.yandexCounter = window['yaCounter' + this.options.yandex.counterId];
            }, this));
        }

        return this;
    };

    /**
     * Configure 3p components
     *
     * @return {WgTemplate}
     *
     * @see http://getuikit.com/docs/documentation_javascript.html
     */
    WgTemplate.prototype.configureComponents = function() {

        // @see http://getuikit.com/docs/dropdown.html#javascript-options
        // UIkit.components.dropdown.prototype.defaults.pos = 'bottom-right';

        //// Configure Joomla handlers

        // Overwrite Joomla.renderMessages to use custom style
        if (window.Joomla && window.Joomla.renderMessages) {

            this.joomlaRenderMessages = Joomla.renderMessages;
            Joomla.renderMessages = this.renderMessages;
        }

        // Overwrite Joomla.removeMessages to use animations
        if (window.Joomla && window.Joomla.removeMessages) {
            this.joomlaRemoveMessages = Joomla.removeMessages;
            Joomla.removeMessages = this.removeMessages;
        }

        // Conigure ScrollDepth plugin (http://scrolldepth.parsnip.io/)
        if (jQuery.scrollDepth) {
            jQuery.scrollDepth({
                // {integer} [minHeight=0]
                // {array} [elements=[]]
                // {boolean} [percentage=true]
                // {boolean} [userTiming=true]
                // {boolean} [pixelDepth=true]
                // {boolean} [nonInteraction=true]
                // {boolean} [gtmOverride=false]
                // {string} [dataLayer='dataLayer']
                // {string} [trackerName=false]
                // {string} [gaGlobal=false]
                // {function} [eventHandler]
            });
        }


        //// Configure extensions

        // Finder extensions
        if (WgTemplate.PkgFinder) {
            jQuery('[data-wg-pkg-finder]').each(jQuery.proxy(WgTemplate.PkgFinder.getInstance, this));
        }

        // Slideshowkit extension
        if (WgTemplate.PkgSlideshowkit) {
            jQuery('[data-wg-pkg-slideshowkit]').each(jQuery.proxy(WgTemplate.PkgSlideshowkit.getInstance, this));
        }

        // Content
        if (WgTemplate.PkgContent) {
            jQuery('[data-wg-pkg-content]').each(jQuery.proxy(WgTemplate.PkgContent.getInstance, this));
        }

        return this;
    };

    /**
     * Register extension
     *
     * @type {function}
     *
     * @return {WgTemplate}
     */
    WgTemplate.prototype.registerExtension = function(extension) {

        this.extensions.push(extension);

        return this;
    };

    //// Event callbacks

    /**
     * [event listener]
     *
     * @param {jQuery.Event} event
     */
    WgTemplate.prototype.onWindowScroll = function(event) {

        this.$els.headerBar.toggleClass('wg-section-headerbar--sticky', this.$els.window.scrollTop() > 0); // this.headerBarHeight

        /*
        // Slideshow parallax effect
        var $slideshow = jQuery('.wg-slidenav > .uk-slideshow');
        var windowTop = this.$els.window.scrollTop();

        var slideshowHeight = Math.max(0, this.slideshowContainerOriginalHeight - windowTop);
        var slideshowMargin = windowTop;

        jQuery('.wg-slidenav').addClass('wg-slidenav-parallax');

        $slideshow.css({
            marginTop: slideshowMargin * 1/3,
            marginBottom: -slideshowMargin * 1/3
            // marginTop: Math.min(0, -slideshowMargin * 2/3),
            // marginBottom: Math.min(0, -slideshowMargin * 1/3)
        });
        /**/
    };

    /**
     * Redirect
     * [event listener]
     *
     * @param {jQuery.Event} event
     */
    WgTemplate.prototype.onOptionMenuChange = function(event) {

        var $target = jQuery(event.target);
        var $option = $target.find('> option:selected');
        var url = $option.data('wgOptionmenuUrl');

        if (url) {
            // Similar to clicking on a link
            window.location.href = url;
        }
    };

    /**
     * Change ordering of articles
     * [event listener]
     *
     * @param {jQuery.Event} event
     */
    WgTemplate.prototype.onOrderingMenuChange = function(event) {

        if (window.Joomla) {
            Joomla.submitform('display', event.target.form);
        }
    };

    /**
     * Open external links in new window
     *
     * @param {jQuery.Event} event
     *
     * @see https://css-tricks.com/snippets/jquery/open-external-links-in-new-window/
     */
    WgTemplate.prototype.onLinkClick = function(event) {

        var el = event.target;
        var $el = jQuery(event.target);

        // Compare if hosts match
        if (el.hostname && el.hostname != window.location.hostname && !$el.attr('target')) {
            $el.attr('target', 'external');
        }
    };

    /**
     * Track clicks on snapshot button
     * @param {jQuery.Event} event
     */
    WgTemplate.prototype.onSnapshotButtonClick = function(event) {

        // see https://yandex.com/support/metrica/reports/add-goals.xml
        if (this.yandexCounter) {
            this.yandexCounter.reachGoal('plgContentPczLoadVideo-snapshotButton-click', {});
        }
    };

    /**
     * Initialize Facebook SDK
     *
     * @return {WgTemplate}
     * @see https://developers.facebook.com/docs/javascript/reference/FB.init/v2.9
     */
    WgTemplate.prototype.initializeFacebook = function() {

        jQuery
            .when(isDomLoaded())
            .then(jQuery.proxy(this.initializeFacebookDelayed, this));
    }

    WgTemplate.prototype.initializeFacebookDelayed = function() {

        FB.init({
            // App ID
            appId: this.options.facebook.appId,
            // autoLogAppEvents: true,
            // Parse XFBML plugins
            // xfbml: true,
            version: 'v' + (this.options.facebook.version || '2.9'),
        });

        var eventElement = jQuery(window);

        // Trigger custom events
        FB.Event.subscribe('xfbml.render', function(a, b, c) {
            eventElement.trigger('wgTemplate:fbRender');
        });

        eventElement.trigger('wgTemplate:fbInit');

        /*
        // page ID is // 755782454507986
        // Login user (blocked popup window)

        FB.login(function(response) { console.log(response); });

        // Check likes using api (requirees user token)
        FB.api('/me/likes/755782454507986', function(response) {
          console.log(response);
        });

        // Doesn't work anymore
        FB.api({
            method: 'pages.isFan',
            page_id: '755782454507986'
        }, function(response) {
            console.log('foobar', response);
        });
        */

        return this;
    };

    /**
     * Overwritten system messages handler
     *
     * @param {Object} messages
     * @param {array} [messages.error]
     * @param {array} [messages.notice]
     * @param {array} [messages.message]
     * @param {booleam} [noLargeModifier=false]
     */
    WgTemplate.prototype.renderMessages = function(messages, useLargeModifier) {

        /** @type {HTMLElement} */
        var messageContainer = document.getElementById('system-message-container');
        /** @type {string} */
        var type;
        /** @type {array} */
        var typeMessages;
        /** @type {HTMLElement} */
        var messagesBox;
        /** @type {string} */
        var alertClass;
        /** @type {HTMLElement} */
        var buttonWrapper;
        /** @type {string} */
        var title;
        /** @type {HTMLElement} */
        var titleWrapper;
        /** @type {integer} */
        var i;
        /** @type {HTMLElement} */
        var messageWrapper;

        // Cleanup previous messages
        Joomla.removeMessages();

        // Itinerate over types
        for (type in messages) {

            typeMessages = messages[type];

            // Create alert box
            messagesBox = document.createElement('div');

            // Message class
            alertClass = 'uk-alert';

            if (useLargeModifier) {
                alertClass += ' uk-alert-large';
            }

            switch (type) {
                // Success (green)
                case 'message':
                    alertClass += ' uk-alert-success';
                    break;

                // Warning (yellow)
                case 'notice':
                    alertClass += ' uk-alert-warning';
                    break;

                // Danger (red)
                case 'error':
                    alertClass += ' uk-alert-danger';
                    break;

                // Other (blue)
                default:
                    alertClass += ' uk-alert-' + type;
                    break;
            }

            messagesBox.className = alertClass;
            messagesBox.setAttribute('data-uk-alert', '');

            // Close button
            buttonWrapper = document.createElement('button');
            buttonWrapper.setAttribute('type', 'button');
            buttonWrapper.className = 'uk-alert-close uk-close';
            messagesBox.appendChild(buttonWrapper);

            // Title

            title = Joomla.JText._(type);

            // Skip titles with untranslated strings
            if (title !== undefined) {
                titleWrapper = document.createElement('h2');
                titleWrapper.innerHTML = title;
                messagesBox.appendChild(titleWrapper);
            }

            // Add messages to the message box
            for (i = typeMessages.length - 1; i >= 0; i--) {
                messageWrapper = document.createElement('div');
                messageWrapper.innerHTML = typeMessages[i];
                messagesBox.appendChild(messageWrapper);
            }

            messageContainer.appendChild(messagesBox);
        }
    };

    /**
     * Remove messages using uikit animation
     *
     * @see ukit/src/js/core/alert.js
     */
    WgTemplate.prototype.removeMessages = function() {

        /** @type {HTMLElement} */
        var $messageContainer = jQuery('#system-message-container');
        var $messageBoxes = $messageContainer.find('[data-uk-alert]');

        $messageBoxes.each(function(i, element) {
            var $ele = jQuery(element);
            var alert = UIkit.alert($ele, UIkit.Utils.options($ele.attr('data-uk-alert')));
            alert.close();
        });
    };

    //// Helpers

    /**
     * DOM ready as a promise
     *
     * @return {Object} - Deferred promise
     */
    function isDomReady() {

        var deferred = jQuery.Deferred();

        jQuery(document).on('ready', deferred.resolve);

        return deferred.promise();
    }

    /**
     * Window load as a promise
     *
     * @return {Object} - Deferred promise
     */
    function isDomLoaded() {

        var deferred = jQuery.Deferred();

        jQuery(window).on('load', deferred.resolve);

        return deferred.promise();
    }

    return WgTemplate;

}(jQuery));
